import { DatePipe, ViewportScroller } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { ConfirmationComponent } from '@shared/components/confirmation/confirmation.component';
import { AlertMessageService } from '@shared/services/alert-message.service';
import { AuthService } from '@shared/services/auth.service';
import { BreadcrumbService } from '@shared/services/breadcrumb.service';
import { CurrentUserService } from '@shared/services/current-user.service';
import { LoadingService } from '@shared/services/loading.service';
import { MessagePollingService } from '@shared/services/message-polling.service';
import { isExternalClientSession } from '@shared/utils/external-client-language.helper';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, BreadcrumbsComponent, HeaderComponent, ConfirmationComponent, ButtonModule, ProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [AlertMessageService, DatePipe],
})
export class AppComponent implements OnInit {
  router = inject(Router);
  viewportScroller = inject(ViewportScroller);
  breadcrumbService = inject(BreadcrumbService);
  loadingService = inject(LoadingService);
  currentUserService = inject(CurrentUserService);
  authService = inject(AuthService);
  messagePollingService = inject(MessagePollingService);

  url = '';

  // External clients (flag login) get a chrome-less checkup: hiding the global header/breadcrumbs
  // reclaims space, especially on mobile. Their language is preserved via the persisted flag choice.
  get isExternal(): boolean {
    return isExternalClientSession(localStorage);
  }

  get isChromeless(): boolean {
    return this.url.startsWith('/company/') || this.url.startsWith('/feedback') || this.isExternal;
  }

  ngOnInit() {
    void this.authService.restoreSession();

    this.messagePollingService.startPolling();

    // Con esto navegamos siempre al TOP del scroll
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.viewportScroller.scrollToPosition([0, 0]);
      this.url = event.urlAfterRedirects;
    });
  }
}
